import React from 'react'

function Whychoos_as() {
  return (
    <div>

      <div className="choose-about-area sp1">
         <div className="space70"></div>
                 <div className="space70"></div>
                        
  <div className="container">
    
    <div className="row">
      <div className="col-lg-12">
        <div className="choose-button-area">
        <ul className="nav nav-pills" id="pills-tab" role="tablist">
          <li className="nav-item" role="presentation">
            <button className="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Our Mission</button>
          </li>
          <li className="nav-item" role="presentation">
            <button className="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false" tabindex="-1">Our Vision</button>
          </li>
          <li className="nav-item" role="presentation">
            <button className="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false" tabindex="-1">Why Choose us </button>
          </li>

        </ul>
        </div>
        <div className="space50"></div>
        <div className="tab-content" id="pills-tabContent">
          <div className="tab-pane fade active show" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabindex="0">
            <div className="row">
              <div className="col-lg-6">

             <div className="vision-card icons">
            <img src="assets/img/icons/c-icons3.svg" alt="Vision Icon" class="vision-icon"/>
            <div className="vision-title">OUR MISSION</div>
            <div className="vision-text">
              Our mission is to be a catalyst for organizational success by attracting, nurturing, and managing talent through personalized, data-driven HR strategies.
            </div>
          </div>

             </div>

              <div className="col-lg-6">
                <div className="img1">
                  <img src="assets/img/all-images/others/Our_mission.png" alt="Our Mission"/>
                </div>
              </div>
            </div>
          </div>  
          <div className="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">
            <div className="row">
              <div className="col-lg-6">

                     <div className="vision-card icons">
            <img src="assets/img/icons/c-icons3.svg" alt="Vision Icon" class="vision-icon"/>
            <div className="vision-title">OUR VISION</div>
            <div className="vision-text">
             To redefine the future of work by connecting top talent with purposeful careers and enabling businesses to achieve excellence through strategic people solutions.
            </div>
          </div>
              </div>
                <div className="col-lg-6">
                <div className="img1">
                  <img src="assets/img/all-images/others/Our_vision.png" alt="Our Vision"/>
                </div>
              </div>
            </div>
          </div>
          <div className="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab" tabindex="0">
            <div className="row">
              <div className="col-lg-6">
                 <div className="choose-heading">
                  <h4>Tailored Hiring Solutions</h4>
                  <div className="space20"></div>
                  <p>We don’t just fill positions — we align talent with your business goals.</p>
                   <div className="space32"></div>
                  <div className="choose2-boxarea aos-init aos-animate" data-aos="fade-left" data-aos-duration="1200">
                    <div className="icons">
                      <img src="assets/img/icons/c-icons1.svg" alt=""/>
                    </div>
                    <div className="text-area">
                      <a href="service-single.html">Job-Ready Talent</a>
                      <div className="space16"></div>
                      <p>Our candidates are vetted to perform from day one.</p>
                    </div>
                  </div>
                  <div className="space32"></div>
                  <div className="choose2-boxarea aos-init aos-animate" data-aos="fade-left" data-aos-duration="1300">
                    <div className="icons">
                      <img src="assets/img/icons/c-icons2.svg" alt=""/>
                    </div>
                    <div className="text-area">
                      <a href="#">Customized Workforce Strategies</a>
                      <div className="space16"></div>
                      <p>Every business is unique — so are our HR solutions.</p>
                    </div>
                  </div>

                  <div className="space32"></div>
                  <div className="choose2-boxarea aos-init aos-animate" data-aos="fade-left" data-aos-duration="1300">
                    <div className="icons">
                      <img src="assets/img/icons/c-icons3.svg" alt=""/>
                    </div>
                    <div className="text-area">
                      <a href="service-single.html">Performance Development Focus</a>
                      <div className="space16"></div>
                      <p>We help teams grow with structured KRAs, KPIs, and employee support.</p>
                    </div>
                      </div>
                        <div className="space16"></div>
                                          <div className="choose2-boxarea aos-init aos-animate" data-aos="fade-left" data-aos-duration="1300">
                   <div className="icons">
                      <img src="assets/img/icons/End-to-End_HR_Support_icon.png" alt=""/>
                    </div>
                    <div className="text-area">
                      
                      <a href="service-single.html">End-to-End HR Support: </a>
                      <div className="space16"></div>
                      <p>From manpower sourcing to policy structuring — we manage it all.</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="img1">
                  <img src="assets/img/all-images/others/why_choose_us.png" alt=""/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
    </div>
  )
}

export default Whychoos_as

